import apollo from 'apollo';

import { AsyncActionHandler } from 'action-handler';
import { tileInstallMutate } from 'queries';
import { fetchInstalledApps } from 'actions/registry';
import { permissionsToRegistry } from 'actions/registry/update-permissions';
import App from 'models/app';

export default new AsyncActionHandler({
  name: 'mark_tile_installed',
  stateProp: 'markTileInstalled',
  handler: (id) => async (dispatch, getState) => {
    const state = getState();

    const app = App.selectFromState(id, state);

    let permissions;
    if (app.grantedPermissions) {
      permissions = permissionsToRegistry(app.grantedPermissions);
    }

    await apollo.mutate({
      mutation: tileInstallMutate,
      variables: {
        id,
        permissions
      }
    });

    await dispatch(fetchInstalledApps());
  }
});
